<template>
  <div class="oscar">
    <header class="oscar__header" v-if="showChrome">
      <b-navbar toggleable="md" type="dark">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
        <b-navbar-brand :to="{ name: 'campaigns-index' }">
          <img :src="logo" alt="Oscar" width="100px" />
        </b-navbar-brand>

        <b-collapse is-nav id="nav_collapse">
          <b-navbar-nav>
            <!-- <b-nav-item :to="{ name: 'dashboard-index' }" v-if="userToken">Dashboard</b-nav-item>
            <b-nav-item :to="{ name: 'contacts-index' }" v-if="userToken">Contacts</b-nav-item>
            <b-nav-item :to="{ name: 'applications-index' }" v-if="userToken">Applications</b-nav-item> -->
            <b-nav-item :to="{ name: 'campaigns-index' }" v-if="userToken">Campaigns</b-nav-item>
            <b-nav-item :to="{ name: 'templates-index' }" v-if="userToken">Templates</b-nav-item>
          </b-navbar-nav>

          <b-navbar-nav class="ml-auto">
            <b-nav-item :href="referrer ? referrer : backendUrl">Back to Oscar</b-nav-item>
            <b-nav-item :to="{ name: 'login' }" v-if="!userToken">Login</b-nav-item>
            <b-nav-item :to="{ name: 'logout' }" v-if="userToken">Logout</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </header>

    <main>
      <router-view></router-view>
    </main>

    <global-loader :loading="isLoading"></global-loader>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import GlobalLoader from './components/GlobalLoader'
import logo from './static/images/oscar-logo.svg'

export default {
  components: {
    GlobalLoader
  },

  data() {
    return {
      logo: '',
      backendUrl: process.env.VUE_APP_BACKEND_URL,
      showChrome: true
    }
  },

  created() {
    // check if we should hide the header and other site "chrome"
    let url = new URL(location.href)
    this.showChrome = !url.searchParams.has('nochrome')
    this.logo = logo
  },

  computed: {
    ...mapState([
      'userToken',
      'referrer',
      'isLoading'
    ])
  }
}
</script>
